import { render, staticRenderFns } from "./AdditionalAddress.vue?vue&type=template&id=61183059&scoped=true"
import script from "./AdditionalAddress.vue?vue&type=script&lang=ts"
export * from "./AdditionalAddress.vue?vue&type=script&lang=ts"
import style0 from "./AdditionalAddress.vue?vue&type=style&index=0&id=61183059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61183059",
  null
  
)

export default component.exports